var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#02FFF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#02D0C9"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#02FFF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#02ACAA"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,12.9c-0.1,0-0.2,0.1-0.3,0.2l-1.7,5.8c0,0.1,0,0.2,0,0.3c0.1,0.1,0.1,0.1,0.2,0.1h2.5l-1.6,4 c-0.1,0.1,0,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4-0.1l4.7-5.8c0.1-0.1,0.1-0.2,0-0.3c0-0.1-0.2-0.2-0.3-0.2H18l2.1-4 c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.1-0.2-0.3-0.2H16.3z",
    fill: "url(#gradient1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2,3h-3.4V0.9h-6.3V3h-3.5C9.9,3,9,3.9,9,4.9v26.9c0,1,0.8,1.8,1.8,1.8h13.2c1,0,1.8-0.8,1.8-1.8V4.9 C26,3.9,25.2,3,24.2,3z M11.5,5.4h3.1h5.8h3.1c0.4,0,0.7,0.3,0.7,0.7v25.1H10.8V6.1C10.8,5.7,11.1,5.4,11.5,5.4z",
    fill: "url(#gradient2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.ccb3a9e7b939f5090e4dc93a18fedc1b.svg";
export { ForwardRef as ReactComponent };